// assets
import {
  IconDashboard,
  IconDeviceAnalytics,
  IconPhoto,
  IconFileText,
  IconWritingSign,
  IconManualGearbox,
  IconApps,
  IconInfoSquare,
  IconClipboardCheck,
  IconTypography,
  IconFiles,
  IconReceipt2
} from '@tabler/icons';

// constant
const icons = {
  IconDashboard,
  IconDeviceAnalytics,
  IconPhoto,
  IconFileText,
  IconWritingSign,
  IconManualGearbox,
  IconApps,
  IconInfoSquare,
  IconClipboardCheck,
  IconTypography,
  IconFiles,
  IconReceipt2
};

// ===========================|| DASHBOARD MENU ITEMS ||=========================== //

const dashboard = {
  id: 'pagesLabel',
  title: 'Pages',
  type: 'group',
  children: [
    {
      id: 'scanImagesLabel',
      title: 'Scan Images',
      type: 'item',
      url: '/',
      icon: icons.IconPhoto,
      breadcrumbs: false
    },
    {
      id: 'scanPdfLabel',
      title: 'Scan Pdfs',
      type: 'item',
      url: '/pdfs',
      icon: icons.IconFileText,
      breadcrumbs: false
    },
    {
      id: 'batchOCRLabel',
      title: 'Batch OCR',
      type: 'item',
      url: '/batch-ocr',
      icon: icons.IconFiles,
      breadcrumbs: false
    },
    {
      id: 'imageToWord',
      title: 'Image to Word',
      type: 'item',
      url: '/image-to-word',
      icon: icons.IconFileText,
      breadcrumbs: false
    },
    {
      id: 'imageToExcel',
      title: 'Image to Excel',
      type: 'item',
      url: '/image-to-excel',
      icon: icons.IconClipboardCheck,
      breadcrumbs: false
    },
    {
      id: 'receiptOcr',
      title: 'Receipt OCR',
      type: 'item',
      url: '/receipt-ocr',
      icon: icons.IconReceipt2,
      breadcrumbs: false
    },
    {
      id: 'pdfToText',
      title: 'PDF to Text',
      type: 'item',
      url: '/pdf-to-text',
      icon: icons.IconFiles,
      breadcrumbs: false
    },
    {
      id: 'screenshotToText',
      title: 'Screenshot to Text',
      type: 'item',
      url: '/screenshot-to-text',
      icon: icons.IconDeviceAnalytics,
      breadcrumbs: false
    },
    {
      id: 'captureFromBrowser',
      title: 'Capture From Browser',
      type: 'item',
      url: '/screen',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'handwritingToText',
      title: 'Handwriting to Text',
      type: 'item',
      url: '/handwriting-to-text',
      icon: icons.IconWritingSign,
      breadcrumbs: false
    },
    {
      id: 'editImagesLabel',
      title: 'Edit Images',
      type: 'item',
      url: '/editor',
      icon: icons.IconWritingSign,
      breadcrumbs: false
    },
    {
      id: 'downloadLabel',
      title: 'Downloads',
      type: 'item',
      url: '/downloads',
      icon: icons.IconApps,
      breadcrumbs: false
    },
    {
      id: 'gettingStartedLabel',
      title: 'Getting Started',
      type: 'item',
      url: '/started',
      icon: icons.IconInfoSquare,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
